/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid } from '@coursera/cds-core';

type Props = {
  header: React.ReactNode;
} & React.HTMLAttributes<HTMLElement>;

const styles = {
  container: () => css`
    margin-bottom: var(--cds-spacing-300);
    border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    border-radius: var(--cds-spacing-300);
  `,
  title: () => css`
    padding: 16px 24px;
    background-color: var(--cds-color-neutral-background-primary-weak);
    border-bottom: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    border-radius: var(--cds-spacing-300) var(--cds-spacing-300) 0 0;
  `,
  children: css`
    padding: 24px;
  `,
};

export const CardWithHeader = ({ header, children, ...props }: Props) => {
  return (
    <Grid container css={styles.container} {...props}>
      <Grid item xs={12} css={styles.title}>
        {header}
      </Grid>
      <Grid item xs={12} css={styles.children}>
        {children}
      </Grid>
    </Grid>
  );
};
